import React, { useRef, useState } from "react"
import PropTypes from "prop-types"

import {
	Placeholder,
	PlaceholderImage,
	Picture,
	PictureContainer,
	BlurEffect
} from "./styles"

import noCoverPlaceholder from "../../assets/no_cover_placeholder_transparent.png"

const Cover = props => {
	const [blur, setBlur] = useState("")
	const { src } = props

	const pictureRef = useRef(null)

	const setCoverBlur = ({ currentTarget }) => {
		const { innerWidth: screenWidth, innerHeight: screenHeight } = window
		const { naturalWidth: pictureWidth, naturalHeight: pictureHeight } = currentTarget

		const amount = Math.max( screenWidth - pictureWidth, screenHeight - pictureHeight)

		if (amount <= 200) {
			setBlur("")
		} else if (amount < 400) {
			setBlur("1px")
		} else if (amount < 800) {
			setBlur("2px")
		} else if (amount < 1000) {
			setBlur("4px")
		} else if (amount < 1200) {
			setBlur("8px")
		} else {
			setBlur("16px")
		}
	}

	if (src) {
		return (
			<PictureContainer>
				<BlurEffect blur={blur} />
				<Picture ref={pictureRef} src={src} onLoad={setCoverBlur} />
			</PictureContainer>
		)
	} else {
		return (
			<Placeholder>
				<PlaceholderImage src={noCoverPlaceholder} />
			</Placeholder>
		)
	}
}

Cover.defaultProps = {
	src: null
}

Cover.propTypes = {
	src: PropTypes.string
}

export default Cover
